(() => {
 const setup=()=>document.querySelectorAll('[data-home-catalog]').forEach(section=>{
  if(section.dataset.filtersReady)return;
  section.dataset.filtersReady='true';
  const cards=[...section.querySelectorAll('[data-discovery-book]')];
  const buttons=[...section.querySelectorAll('[data-style-filter]')];
  const select=section.querySelector('[data-style-select]');
  const known=new Set(buttons.map(button=>button.dataset.styleFilter));
  const apply=(style,updateUrl=true)=>{
   if(!known.has(style))style='all';
   let count=0;
   cards.forEach(card=>{const visible=style==='all'||card.dataset.bookCategory.split('|').includes(style);card.hidden=!visible;if(visible)count+=1;});
   if(select)select.value=style;
   buttons.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.styleFilter===style)));
   section.querySelector('[data-catalog-results]').textContent=section.dataset.resultsTemplate.replace('[count]',count).replace('[total]',cards.length);
   if(updateUrl){const url=new URL(location.href);if(style==='all')url.searchParams.delete('style');else url.searchParams.set('style',style);history.replaceState(null,'',url);}
   requestAnimationFrame(()=>section.dispatchEvent(new CustomEvent('sc:catalog-filter',{bubbles:true})));
  };
  select?.addEventListener('change',()=>apply(select.value));
  buttons.forEach(button=>button.addEventListener('click',()=>apply(button.dataset.styleFilter)));
  document.querySelectorAll('[data-category-link]').forEach(link=>link.addEventListener('click',event=>{event.preventDefault();apply(link.dataset.categoryLink);section.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}));
  addEventListener('popstate',()=>apply(new URL(location.href).searchParams.get('style')||'all',false));
  apply(new URL(location.href).searchParams.get('style')||'all',false);
 });
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup);else setup();
 document.addEventListener('shopify:section:load',setup);
})();
